import { client } from './client';
import interceptors from './interceptors';
import qs from 'qs';

client.interceptors.request.use(interceptors.noAuth, interceptors.onError);

function checkCart(params) {
	return client.post('/tunnel/api/public/cart/check', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}

function checkSponsor(params) {
	return client.get('/tunnel/api/public/transaction/check_sponsor', {
		params: {
			sponsor_mid: params
		}
	});
}

function checkMandatory(type, data) {
	return client.get('/tunnel/api/public/registration/mandatory_check', {
		params: {
			type: type,
			data: data
		}
	});
}

export default {
	checkCart,
	checkSponsor,
	checkMandatory
}